<div class="background-color">
    <div>
        <app-svg name="{{name}}"></app-svg>
    </div>
    
</div>
